<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>
  <div class="bg-white mx-1 bottom-page-shadow rounded-bottom-extra">
    <div class="row  ps-3">
      <div class="col pt-3 ">
        <p> <span class="fw-bold">Penyenggaraan</span> - Daftar Baharu</p>
      </div>
    </div>
    <div class="row">
      <div class="col pt-3 mx-5">
        <p class="text-muted">Sila masukkan No. Pengenalan</p>
      </div>
    </div>
    <div class="row pb-5 ms-5">
      <div class="col-3">
        <select class="form-select border-0 shadow" aria-label="Search type" [(ngModel)]="IDTypeInput" [ngModelOptions]="{standalone: true}">
          <option value="" selected>Jenis Pengenalan</option>
          <option value="1">MyKad/MyPR/MyKAS</option>
          <option value="2">No. Pasport/Dokumen lain</option>
          <!--<option value="3">Tentera</option>-->
          <!--<option value="4">Polis</option>-->
        </select>
      </div>
      <div class="col-2">
        <input type="text" class="form-control border-0 shadow" placeholder="No. Pengenalan" [(ngModel)]="IDNoInput" [ngModelOptions]="{standalone: true}">
      </div>
      <div class="col-5">
        <div class="btn-toolbar d-flex justify-content-center">
          <div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2" role="button" (click)="Hantar(IDTypeInput,IDNoInput)">Hantar</button>
          </div>
          <div class="me-2">
            <button type="button" class="btn grey-default-button border-0 shadow rounded-2" role="button" (click)="Semula()">Semula</button>
          </div>
          <div class="me-2">
            <button type="button" class="btn grey-default-button border-0 shadow rounded-2" role="button" routerLink="/daftar-kemaskini">Kembali</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row pb-5 ms-5">
      <div class="col pt-3" *ngIf="ViewRegisterAgentOnly">
        <p class="fw-bold text-danger">Tiada rekod ejen cukai yang sah didaftarkan dalam firma. Sila lakukan pendaftaran ejen cukai yang sah bagi membenarkan akses ke firma </p>
      </div>
    </div>
    <div class="accordion px-5 pb-5" id="resultAcordion" *ngIf="SearchStatus">
        <div class="accordion-item border-0">
            <h2 class="accordion-header m-0" id="headingOne">
            <button class="accordion-button primary-colour text-black shadow rounded-top-extra" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                Butiran Carian
            </button>
            </h2>
            <div id="collapseOne" class="accordion-collapse collapse show bottom-page-shadow default-content-bg-colour rounded-bottom-extra" aria-labelledby="headingOne" data-bs-parent="#resultAcordion">
              <div class="accordion-body">
                <div class="row">
                  <div class="col-2">
                    <p>Nama</p>
                  </div>
                  <div class="col-1">
                    <p class="text-end">:</p>
                  </div>
                  <div class="col-3">
                    <p><strong>{{ViewName}}</strong></p>
                  </div>

                  <div class="col-2">
                    <p>No. Pengenalan</p>
                  </div>
                  <div class="col-1">
                    <p class="text-end">:</p>
                  </div>
                  <div class="col-2">
                    <p><strong>{{ViewIDNo}}</strong></p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-2">
                    <p>Jenis Pengenalan</p>
                  </div>
                  <div class="col-1">
                    <p class="text-end">:</p>
                  </div>
                  <div class="col-2">
                    <p><strong>{{ViewIDTypeString}}</strong></p>
                  </div>

                  <div class="col-2 offset-1">
                    <p>TIN</p>
                  </div>
                  <div class="col-1">
                    <p class="text-end">:</p>
                  </div>
                  <div class="col-2">
                    <p><strong>{{ViewItRefNo}}</strong></p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-2">
                    <p>Tarikh Lahir</p>
                  </div>
                  <div class="col-1">
                    <p class="text-end">:</p>
                  </div>
                  <div class="col-3">
                    <p><strong>{{ViewDateOfBirth}}</strong></p>
                  </div>
                  <div class="col-2">
                    <p>Emel Pengguna</p>
                  </div>
                  <div class="col-1">
                    <p class="text-end">:</p>
                  </div>
                  <div class="col-1">
                    <p><strong>{{ViewPersonalEmail}}</strong></p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-2">
                    <p>Tempoh Sijil Digital</p>
                  </div>
                  <div class="col-1">
                    <p class="text-end">:</p>
                  </div>
                  <div class="col-3">
                    <p><strong>{{ViewUserCertStart === 'N/A' ? ViewUserCertStart : ViewUserCertStart + ' - ' + ViewUserCertEnd}}</strong></p>
                  </div>
                </div>

                <div *ngIf="ViewUserFirmEmail === null" class="row pt-2">
                  <div class="col-2">
                    <p>Peranan Pengguna</p>
                  </div>
                  <div class="col-1">
                    <p class="text-end">:</p>
                  </div>
                  <div class="col-3" *ngIf="!ViewRegisterAgentOnly">
                    <select class="form-select border-0 shadow" aria-label="Role Select" [(ngModel)]="RoleInput" [ngModelOptions]="{standalone: true}">
                      <option value="">Sila pilih</option>
                      <option value="0201">Pentadbir</option>
                      <option value="0202">Penyelia</option>
                      <option value="0203">Staf</option>
                      <option value="0204">Ejen Cukai</option>
                    </select>
                  </div>

                  <div class="col-3" *ngIf="ViewRegisterAgentOnly">
                    <p class="fw-bold">Ejen Cukai</p>
                  </div>

                  <div class="col-2">
                    <p>e-mel Ejen Cukai</p>
                  </div>
                  <div class="col-1">
                    <p class="text-end">:</p>
                  </div>
                  <div class="col-3">
                    <input type="email" class="form-control border-0 shadow" placeholder="Emel Pengguna" [(ngModel)]="EmailInput" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>

                <div *ngIf="ViewUserFirmEmail !== null" class="row pt-2">
                  <div class="col-2">
                    <p>Peranan Pengguna</p>
                  </div>
                  <div class="col-1">
                    <p class="text-end">:</p>
                  </div>
                  <div class="col-3" *ngIf="!ViewRegisterAgentOnly">
                    <select class="form-select border-0 shadow" aria-label="Role Select" [(ngModel)]="RoleInput" [ngModelOptions]="{standalone: true}">
                      <option value="">Sila pilih</option>
                      <option value="0201">Pentadbir</option>
                      <option value="0202">Penyelia</option>
                      <option value="0203">Staf</option>
                      <option value="0204">Ejen Cukai</option>
                    </select>
                  </div>

                  <div class="col-3" *ngIf="ViewRegisterAgentOnly">
                    <p class="fw-bold">Ejen Cukai</p>
                  </div>
                  <div class="col-2">
                    <p>Emel Pengguna Firma</p>
                  </div>
                  <div class="col-1">
                    <p class="text-end">:</p>
                  </div>
                  <div class="col-3">
                    <p><strong>{{ViewUserFirmEmail}}</strong></p>
                  </div>
                </div>


                <div class="btn-toolbar d-flex justify-content-end pt-3">
                  <div class="me-2">
                    <button type="button" class="btn submit-button border-0 shadow rounded-2 bg-white" role="button" (click)="StaffRegister(ViewIDType,ViewIDNo,ViewRegisterAgentOnly ? '0204' : RoleInput,ViewUserFirmEmail === null ? EmailInput : ViewUserFirmEmail)">Hantar</button>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
  </div>
</div>
